import { WIDGET_FORM_INPUT_SELECT } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const SelectInputWidget: WidgetRegistryEntry = {
  name: WIDGET_FORM_INPUT_SELECT,
  component: () => import("./select-input-widget.component").then((m) => m.SelectInputWidgetComponent)
};
